import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { ENDPOINT, IMAGE_BASE_URL } from "../../../endpoints/endpoints";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import dayjs from "dayjs";

const LiveUpdate = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    category_id: "",
    league_id: "",
    team1_id: "",
    team2_id:"",
    startdate:dayjs(),
    starttime:dayjs(),
    sd_link1:"",
    sd_link2:"",
    sd_link3:"",
    hd_link1:"",
    hd_link2:"",
    hd_link3:""
  });

  const token = localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);

  // ==== League Data ====
  const [leagues, setLeagues] = useState([]);
  const [leagueSearch, setLeagueSearch] = useState("");
  const [filteredLeagues,setfilteredleague] = useState([]);

  const [teams, setTeams] = useState([]);
  const [teamSearch, setTeamSearch] = useState("");
  const [filteredTeams,setfilteredteam] = useState([]);

  const [categorys, setCategorys] = useState([]);
  const [categorySearch, setCategorySearch] = useState("");
  const [filteredCategorys,setfilteredcategory] = useState([]);

   const { id } = useParams();

  // ============================================================
  // 🔥 Load All League Categories (All Pagination Pages)
  // ============================================================
  useEffect(() => {
    if (!token) {
      toast.warning("Please log in to continue");
      navigate("/login");
    } else {
      fetchAllLeagues();
      fetchAllTeam();
      fetchAllCategory();
      fetchDetail();
    }
  }, [navigate]);

     const fetchDetail = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("accessToken");

        const res = await axios.get(ENDPOINT.LIVE_DETAIL(id), {
          headers: { Authorization: `Bearer ${token}` },
        });
        
setFormData(prev => {
  const data = res.data.result || res.data.data;

  return {
    category_id: data?.category?.id ?? "",
    league_id: data?.league?.id ?? "",
    team1_id: data?.team1?.id ?? "",
    team2_id: data?.team2?.id ?? "",

    startdate: data?.startdate
      ? dayjs(data.startdate, ["YYYY-MM-DD", "MMM DD"])
      : prev.startdate,

    starttime: data?.starttime
      ? dayjs(data.starttime, ["HH:mm:ss", "hh:mm A"])
      : prev.starttime,

    sd_link1: data?.sd_link1 ?? "",
    sd_link2: data?.sd_link2 ?? "",
    sd_link3: data?.sd_link3 ?? "",
    hd_link1: data?.hd_link1 ?? "",
    hd_link2: data?.hd_link2 ?? "",
    hd_link3: data?.hd_link3 ?? ""
  };
});
      } catch (err) {
        toast.error("Failed to fetch live detail");
      } finally {
        setLoading(false);
      }
    };

  const fetchAllLeagues = async () => {
    try {
      let url = ENDPOINT.LEAGUECATEGORY_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setLeagues(allResults);
      setfilteredleague(allResults)
    } catch (error) {
      console.error("Error loading league list:", error);
      toast.error("Failed to load leagues");
    }
  };

  const fetchAllTeam = async () => {
    try {
      let url = ENDPOINT.TEAM_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setTeams(allResults);
      setfilteredteam(allResults)
    } catch (error) {
      console.error("Error loading team list:", error);
      toast.error("Failed to load teams");
    }
  };

  const fetchAllCategory = async () => {
    try {
      let url = ENDPOINT.LIVECATEGORY_LIST;
      let allResults = [];

      while (url) {
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        allResults = [...allResults, ...res.data.results];
        url = res.data.next; // load next pages
      }

      setCategorys(allResults);
      setfilteredcategory(allResults)
    } catch (error) {
      console.error("Error loading category list:", error);
      toast.error("Failed to load categories");
    }
  };

  useEffect(()=>{
  let filteredLeague = leagues.filter((l) =>
    l.name.toLowerCase().includes(leagueSearch.toLowerCase())
  );
  setfilteredleague(filteredLeague)
  },[leagueSearch])

  useEffect(()=>{
  let filteredTeam = teams.filter((t) =>
    t.name.toLowerCase().includes(teamSearch.toLowerCase())
  );
  setfilteredteam(filteredTeam)
  },[teamSearch])

  useEffect(()=>{
  let filteredCategory = categorys.filter((c) =>
    c.name.toLowerCase().includes(categorySearch.toLowerCase())
  );
  setfilteredcategory(filteredCategory)
  },[categorySearch])
  

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  // ============================================================
  // 🚀 Submit Form
  // ============================================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!token) {
        toast.error("You must log in first!");
        navigate("/login");
        return;
      }

      const data = new FormData();
      Object.keys(formData).forEach((key) => {
  if (key === "startdate") {
    data.append(key, formData.startdate.format("YYYY-MM-DD")); // correct format
  } else if (key === "starttime") {
    data.append(key, formData.starttime.format("HH:mm:ss"));   // correct format
  } else {
    data.append(key, formData[key]);
  }
});

      const response = await axios.put(ENDPOINT.LIVE_UPDATE(id), data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      const msg = response.data.message || "Live updated successfully";

      toast.success(msg);
      setTimeout(() => navigate(`/live/${id}`), 1200);
    } catch (err) {
      console.error("Error creating Live:", err);
      toast.error(
        err.response?.data?.message ||
          err.response?.data?.detail ||
          "Something went wrong."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          🖼 Create New Live
        </Typography>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <Stack spacing={2}>

             <FormControl fullWidth>
              <InputLabel id="category-label">Category</InputLabel>

              <Select
                labelId="category-label"
                label="Category"
                name="category_id"
                value={formData.category_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search category..."
                    size="small"
                    value={categorySearch}
                    onChange={(e) => setCategorySearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredCategorys.length} results
                  </Typography>
                </MenuItem>

                {filteredCategorys.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {c.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredLeagues.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

             <FormControl fullWidth>
              <InputLabel id="league-label">League</InputLabel>

              <Select
                labelId="league-label"
                label="League"
                name="league_id"
                value={formData.league_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search league..."
                    size="small"
                    value={leagueSearch}
                    onChange={(e) => setLeagueSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredLeagues.length} results
                  </Typography>
                </MenuItem>

                {filteredLeagues.map((l) => (
                  <MenuItem key={l.id} value={l.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${l.image}`}
                        alt={l.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {l.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredLeagues.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="team1-label">Team 1</InputLabel>

              <Select
                labelId="team1-label"
                label="League"
                name="team1_id"
                value={formData.team1_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search team 1..."
                    size="small"
                    value={teamSearch}
                    onChange={(e) => setTeamSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredTeams.length} results
                  </Typography>
                </MenuItem>

                {filteredTeams.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${t.image}`}
                        alt={t.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {t.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredTeams.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="team2-label">Team 2</InputLabel>

              <Select
                labelId="team2-label"
                label="Team 2"
                name="team2_id"
                value={formData.team2_id}
                onChange={handleChange}
                required
                MenuProps={{ PaperProps: { style: { maxHeight: 350 } } }}
              >
                {/* Search Box */}
                <MenuItem disableRipple>
                  <TextField
                    fullWidth
                    placeholder="Search team 2..."
                    size="small"
                    value={teamSearch}
                    onChange={(e) => setTeamSearch(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()} 
                  />
                </MenuItem>

                <MenuItem disabled>
                  <Typography variant="caption" color="text.secondary">
                    {filteredTeams.length} results
                  </Typography>
                </MenuItem>

                {filteredTeams.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={`${IMAGE_BASE_URL}${t.image}`}
                        alt={t.name}
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          mr: 1.5,
                        }}
                      />
                      {t.name}
                    </Box>
                  </MenuItem>
                ))}

                {filteredTeams.length === 0 && (
                  <MenuItem disabled>No results found</MenuItem>
                )}
              </Select>
            </FormControl>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Date"
              value={formData.startdate}
              onChange={(newValue) =>
                setFormData((prev) => ({ ...prev, startdate: newValue }))
              }
              slotProps={{
                textField: {
                  name: "Date",
                  required: true,
                  fullWidth: true,
                },
              }}
            />

            <TimePicker
              label="Time"
              value={formData.starttime}
              onChange={(newValue) =>
                setFormData((prev) => ({ ...prev, starttime: newValue }))
              }
              slotProps={{
                textField: {
                  name: "Time",
                  required: true,
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>

          <TextField
            label="Live Stream Link SD1"
            name="sd_link1"
            value={formData.sd_link1}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Live Stream Link SD2"
            name="sd_link2"
            value={formData.sd_link2}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Live Stream Link SD3"
            name="sd_link3"
            value={formData.sd_link3}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Live Stream Link HD1"
            name="hd_link1"
            value={formData.hd_link1}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Live Stream Link HD2"
            name="hd_link2"
            value={formData.hd_link2}
            onChange={handleChange}
            fullWidth
          />

          <TextField
            label="Live Stream Link HD3"
            name="hd_link3"
            value={formData.hd_link3}
            onChange={handleChange}
            fullWidth
          />


            {/* Submit Button */}
            <Box textAlign="right" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={loading}
                sx={{ px: 4 }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Update Live"
                )}
              </Button>
            </Box>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default LiveUpdate;
